export default new class PaidVideo {
  constructor() {
    this.paidVideoFigure = 'paid-video-figure';
    this.$paidVideoFigure = $(`.${this.paidVideoFigure}`);

    if (!this.$paidVideoFigure.length) return;

    this.$doc = $(document);

    this.paidVideo = 'paid-video';
    this.preview = '_preview';

    this.init();
  }

  init() {
    this.replaceAllFigure();
    this.eventHandler();
  }

  /**
     * Replace all figure on page
     */
  replaceAllFigure() {
    for (let i = 0; i < this.$paidVideoFigure.length; i += 1) {
      const $this = $(this.$paidVideoFigure[i]);
      const src = $this.attr('data-img');
      const videoId = $this.attr('data-video-id');
      const name = $this.text();

      $this.replaceWith(`
                <div class="paid-video _preview" data-video-id="${videoId}">
                    <img src="${src}" alt="">
                    <div class="paid-video__overlay">
                        <div class="paid-video__title">${name}</div>
                    </div>
                </div>
            `);
    }
  }

  /**
     * Event handlers
     */
  eventHandler() {
    this.$doc.on('click', `.${this.paidVideo}.${this.preview}`, this.getVideo.bind(this));
  }

  async getVideo(e) {
    const $this = $(e.currentTarget);
    const id = $this.attr('data-video-id');

    const { data: { link, partial }, status } = await $.request('UserSubscription::onGetPaidVideo', {
      data: { video_id: id },
    });

    if (!status) {
      $this.replaceWith(partial);
      return;
    }

    const $video = $(`<video src="${link}" controls></video>`);
    $this.replaceWith($video);

    $video.get(0).play();
  }
}();
